/**
 * Cross-selling del mini-cart (CAT).
 *
 * Carrusel (carrito con productos): recomendaciones nativas de Shopify para
 * el primer ítem (complementary → related). Grid (carrito vacío): colección
 * configurada (populares). El layout lo decide el servidor (data-layout), y
 * el drawer re-renderiza su interior en cada cart:update, así que el
 * contenido se repuebla tras cada evento. Ver snippets/cat-cart-upsell.liquid.
 */
(function () {
  'use strict';

  if (window.__catCartUpsell) return;
  window.__catCartUpsell = true;

  var SELECTOR = '.cat-cart-upsell';
  var started = false;
  var currentRun = 0;

  function routesRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  // Formato de moneda de la tienda (shop.money_format, ej. "${{amount}}",
  // "₡{{amount_no_decimals}}"), igual al que usa el resto del sitio.
  function formatMoney(cents, format) {
    var template = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(amount, precision, thousands, decimal) {
      if (isNaN(amount) || amount == null) return '0';
      var fixed = (amount / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var match = template.match(placeholder);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }
    return template.replace(placeholder, value);
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var url = src.startsWith('//') ? 'https:' + src : src;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function isAvailable(product) {
    if (product.available === false) return false;
    var variants = product.variants || [];
    return !variants.length || variants.some(function (v) {
      return v.available !== false;
    });
  }

  async function getCart() {
    try {
      var resp = await fetch(routesRoot() + 'cart.js', { credentials: 'same-origin' });
      return resp.ok ? resp.json() : null;
    } catch (e) {
      return null;
    }
  }

  // Recomendaciones nativas para el producto semilla: primero los
  // complementarios configurados en Search & Discovery; si no hay, related.
  async function fetchRecommendations(seedProductId, limit) {
    var intents = ['complementary', 'related'];
    for (var i = 0; i < intents.length; i++) {
      try {
        var resp = await fetch(
          routesRoot() + 'recommendations/products.json?product_id=' + seedProductId + '&limit=' + limit + '&intent=' + intents[i]
        );
        if (!resp.ok) continue;
        var data = await resp.json();
        if (data.products && data.products.length) return data.products;
      } catch (e) {}
    }
    return [];
  }

  // Colección para carrito vacío (populares). products.json da precios en
  // decimal; se normalizan a centavos para usar el mismo render.
  async function fetchCollectionProducts(handle, limit) {
    try {
      var resp = await fetch(routesRoot() + 'collections/' + handle + '/products.json?limit=' + limit);
      if (!resp.ok) return [];
      var data = await resp.json();
      return (data.products || []).map(function (p) {
        return {
          id: p.id,
          title: p.title,
          url: routesRoot() + 'products/' + p.handle,
          featured_image: (p.images && p.images[0] && p.images[0].src) || '',
          price: Math.round(parseFloat((p.variants && p.variants[0] && p.variants[0].price) || '0') * 100),
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, available: v.available !== false };
          }),
        };
      });
    } catch (e) {
      return [];
    }
  }

  function cardHtml(product, options) {
    var availableVariants = (product.variants || []).filter(function (v) {
      return v.available !== false;
    });
    var single = availableVariants.length === 1 && (product.variants || []).length === 1;

    var cta = single
      ? '<button type="button" class="cat-cart-upsell__add" data-upsell-add="' + availableVariants[0].id + '">+ Agregar al carrito</button>'
      : '<a class="cat-cart-upsell__add" href="' + escapeHtml(product.url) + '">Elegir opciones</a>';

    return (
      '<div class="cat-cart-upsell__card">' +
      '<a href="' + escapeHtml(product.url) + '" class="cat-cart-upsell__img-link" tabindex="-1" aria-hidden="true">' +
      '<img src="' + escapeHtml(imageUrl(product.featured_image, options.imageWidth)) + '" alt="" width="' + options.imageWidth + '" height="' + options.imageWidth + '" loading="lazy">' +
      '</a>' +
      '<div class="cat-cart-upsell__info">' +
      '<a class="cat-cart-upsell__title" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
      '<span class="cat-cart-upsell__price">' + escapeHtml(formatMoney(product.price, options.moneyFormat)) + '</span>' +
      cta +
      '</div>' +
      '</div>'
    );
  }

  async function populate() {
    var el = document.querySelector(SELECTOR);
    if (!el) return;

    // Cada cart:update re-renderiza el drawer y relanza populate: si una
    // corrida vieja termina después de una nueva, se descarta.
    var runId = ++currentRun;
    var isGrid = el.dataset.layout === 'grid';
    var heading;
    var products;

    if (isGrid) {
      // El servidor renderizó el estado vacío: no hace falta pedir el carrito.
      var emptyLimit = parseInt(el.dataset.emptyLimit || '4', 10);
      heading = el.dataset.emptyHeading;
      products = (await fetchCollectionProducts(el.dataset.collection || 'all', emptyLimit * 2))
        .filter(isAvailable)
        .slice(0, emptyLimit);
    } else {
      var limit = parseInt(el.dataset.limit || '8', 10);
      var cart = await getCart();
      if (!cart || runId !== currentRun) return;

      var inCart = {};
      (cart.items || []).forEach(function (item) {
        inCart[item.product_id] = true;
      });

      if (cart.item_count > 0) {
        heading = el.dataset.heading;
        products = await fetchRecommendations(cart.items[0].product_id, limit + 4);
      } else {
        heading = el.dataset.emptyHeading;
        products = await fetchCollectionProducts(el.dataset.collection || 'all', limit + 4);
      }

      products = products
        .filter(function (p) {
          return !inCart[p.id] && isAvailable(p);
        })
        .slice(0, limit);
    }

    if (runId !== currentRun) return;

    // El drawer pudo re-renderizarse durante el fetch: re-buscar el nodo y
    // confirmar que sigue en el mismo layout.
    el = document.querySelector(SELECTOR);
    if (!el || (el.dataset.layout === 'grid') !== isGrid) return;

    if (!products.length) {
      el.setAttribute('hidden', '');
      return;
    }

    var options = {
      imageWidth: isGrid ? 400 : 160,
      moneyFormat: el.dataset.moneyFormat,
    };

    el.querySelector('.cat-cart-upsell__heading').textContent = heading || '';
    el.querySelector('.cat-cart-upsell__track').innerHTML = products
      .map(function (p) {
        return cardHtml(p, options);
      })
      .join('');
    el.removeAttribute('hidden');
  }

  function start() {
    if (started) return;
    started = true;
    populate();
  }

  // Primera carga: al abrir el drawer (o al primer cart:update). Después, se
  // repuebla tras cada cart:update (el morph del drawer limpia el contenido).
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('[data-testid="cart-drawer-trigger"]')) start();
    },
    true
  );

  document.addEventListener('cart:update', function () {
    started = true;
    setTimeout(populate, 250);
  });

  // "+ Agregar al carrito" (productos de una sola variante).
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Agregando…';

    try {
      var resp = await fetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: parseInt(btn.dataset.upsellAdd, 10), quantity: 1 }),
      });
      if (!resp.ok) throw new Error();

      var cartResp = await fetch(routesRoot() + 'cart.js', { credentials: 'same-origin' });
      var cart = cartResp.ok ? await cartResp.json() : null;

      // Sin "sections" en el detalle: el drawer se re-renderiza solo desde el
      // servidor (component-cart-items → renderSection), incluido el cambio
      // de estado vacío → con productos.
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'cat-cart-upsell',
            data: {
              source: 'cat-cart-upsell',
              itemCount: (cart && cart.item_count) || 0,
              variantId: btn.dataset.upsellAdd,
            },
          },
        })
      );
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'No se pudo agregar';
      setTimeout(function () {
        btn.textContent = original;
      }, 1800);
    }
  });
})();
